/*
Grilla Expandible, con un boton que permite agregar datos a la cola.
Maneja los Adicionales de Reserva y Nota de venta
*/
import React, { useState, useEffect } from 'react'

import { FormatProps, handleInputChangeFormat } from '../utils/handleInputChangeFormat'
import { dateToday, formatDateEx, formatWithThousandSep } from '../utils/utils'
import { Rule, validateFields } from '../utils/validateForm'
import { Additional, AdditionalTypeEnum, TransferOwner } from '../interfaces/Reservation'

import { RadioGroup, RadioItem } from './RadioGroup'
import InputField from './InputField'
import { DisplayValueVert } from './DisplayValue'
import { ButtonActionShort, ButtonMenuSet } from './Buttons'
import ConfirmationModal from './ConfirmationModal'

interface GridExpProps {
  title: string
  array: Additional[]
  vehiclePrice: number
  appraisal: number
  onPaymentsChange: (payments: Additional[]) => void
}

interface Transfer {
  varios: number
  varios_format: string
  impuesto: number
  impuesto_format: string
  inscripcion: number
  inscripcion_format: string
  date: string
  price: number
  price_format: string
}

interface Tag {
  date: string
  price: number
  price_format: string
}

interface Otro {
  date: string
  price: number
  price_format: string
  description: string
}
const ReservationAdicional: React.FC<GridExpProps> = ({ title, array, vehiclePrice, appraisal, onPaymentsChange }) => {
  const iniTransfer: Transfer = {
    varios: 0,
    varios_format: '',
    impuesto: 0,
    impuesto_format: '',
    inscripcion: 0,
    inscripcion_format: '',
    date: dateToday(),
    price: 0,
    price_format: '',
  }
  const iniTag: Tag = {
    date: dateToday(),
    price: 0,
    price_format: '',
  }
  const iniOtro: Otro = {
    date: dateToday(),
    price: 0,
    price_format: '',
    description: '',
  }
  const generateIni = (): Additional => ({
    _id: Math.floor(Math.random() * 1000000).toString(),
    description: '',
    date: dateToday(),
    cost: 0,
    //   price_format: ""
  })
  //const [additionals, setAdditionals] = useState<Additional[]>(array);
  const [showPagoEdit, setShowPagoEdit] = useState(false)
  const [selectedIndex, setSelectedIndex] = useState<number>(-1)

  const [transfer, setTransfer] = useState<Transfer | null>(iniTransfer)
  const [tag, setTag] = useState<Tag | null>(iniTag)
  const [otro, setOtro] = useState<Otro | null>(iniOtro)

  const [newAdditional, setNewAdditional] = useState<Additional | null>(generateIni)
  // Este indica si el calculo es sobre el valor de venta o la tasacion
  const [tranIndex, setTranIndex] = useState<number>(0)
  // Errores de validacion de los input
  const [errors, setErrors] = useState<{ [key: string]: string }>({})
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedItemId, setSelectedItemId] = useState<string | null>(null)

  // Aca llega cuando presionan "precio de venta, tasación o "nousar"
  useEffect(() => {
    if (tranIndex < 0) return
    let impuesto = 0
    let impuesto_format = '\u{00A0}'
    let inscripcion = 0
    let inscripcion_format = '\u{00A0}'

    if (transfer) {
      let num = 0

      if (tranIndex === 0) {
        num = vehiclePrice
      } else if (tranIndex === 1) {
        num = appraisal
      }

      if (num !== 0) {
        // TODO: Leer
        inscripcion = 39240
        inscripcion_format = new Intl.NumberFormat().format(inscripcion)
        // TODO: Leer
        impuesto = Math.round(num * 0.015)
        impuesto_format = new Intl.NumberFormat().format(impuesto)
      }
      const varios = transfer.varios
      const total = impuesto + inscripcion + varios
      const total_format = new Intl.NumberFormat().format(total)

      setTransfer({
        ...transfer,
        impuesto: impuesto,
        impuesto_format: impuesto_format,
        inscripcion: inscripcion,
        inscripcion_format: inscripcion_format,
        price: total,
        price_format: total_format,
      })

      // Para limpiar el error que podria estar en el total
      setErrors({})
    }
  }, [vehiclePrice, appraisal, tranIndex, transfer?.varios, transfer?.impuesto])

  const handleInputChangeTx = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const formatProps: FormatProps[] = [
      { name: 'varios', name_format: 'varios_format', isDecimal: false },
      { name: 'impuesto', name_format: 'impuesto_format', isDecimal: false },
    ]
    handleInputChangeFormat<Transfer>(e, transfer, setTransfer, formatProps)
  }
  const handleInputChangeTag = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const formatProps: FormatProps[] = [{ name: 'price', name_format: 'price_format', isDecimal: false }]
    handleInputChangeFormat<Tag>(e, tag, setTag, formatProps)
  }
  const handleInputChangeOtro = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const formatProps: FormatProps[] = [{ name: 'price', name_format: 'price_format', isDecimal: false }]
    handleInputChangeFormat<Otro>(e, otro, setOtro, formatProps)
  }
  // ACA ESTAN LOS CLICKS EN BOTONES=  ====================================
  const handleAgregarClick = () => {
    setTransfer({ ...iniTransfer })
    setNewAdditional(generateIni)
    setShowPagoEdit(true)
  }

  // Cuando acepta los valores del cuadro de Adicionales
  const handlePagoAceptarClick = () => {
    let fieldsToValidate = []

    if (esTransferencia) {
      fieldsToValidate = [
        { name: 'price_format', value: transfer?.price_format, rule: Rule.GREATER_ZERO },
        { name: 'date', value: transfer?.date, rule: Rule.REQUIRED },
      ]
    } else if (esTag) {
      fieldsToValidate = [
        //     { name: "price_format", value: tag?.price_format, rule: Rule.GREATER_ZERO },
        { name: 'date', value: tag?.date, rule: Rule.REQUIRED },
      ]
    } else {
      fieldsToValidate = [
        { name: 'price_format', value: otro?.price_format, rule: Rule.GREATER_ZERO },
        { name: 'date', value: otro?.date, rule: Rule.REQUIRED },
        { name: 'description', value: otro?.description, rule: Rule.REQUIRED },
      ]
    }

    const validationErrors = validateFields(fieldsToValidate)

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors) // Set errors if any

      return
    }
    setErrors({})

    let price = 0
    let date = ''
    let type = 0

    if (newAdditional) {
      let updatedPayment = { ...newAdditional }
      let desc_value

      if (esTransferencia) {
        price = transfer?.price ?? 0

        date = transfer?.date ?? ''
        desc_value = 'Transferencia de dominio'
        type = AdditionalTypeEnum.TransferOwner
        const transferOwner: TransferOwner = {
          taxType: tranIndex,
          calcCost: transfer?.impuesto,
          inscription: transfer?.inscripcion,
          other: transfer?.varios,
        }
        updatedPayment = {
          ...updatedPayment,
          transferOwner: transferOwner,
        }
      } else if (esTag) {
        price = tag?.price ?? 0
        date = tag?.date ?? ''
        desc_value = 'TAG'
        type = AdditionalTypeEnum.Tag
      } else {
        price = otro?.price ?? 0

        date = otro?.date ?? ''
        desc_value = otro?.description ?? ''
        type = AdditionalTypeEnum.Other
      }
      updatedPayment = {
        ...updatedPayment,
        description: desc_value,
        cost: price,
        date: date,
        type: type,
      }

      // Set the updated payment and push it to payments array
      if (updatedPayment) {
        setNewAdditional({ ...updatedPayment })
        // Esto es para resolver un problema de la "asincronicidad "
        //setAdditionals((prevPayments) => [...prevPayments, updatedPayment]);
        const newArray = [...array, updatedPayment]
        onPaymentsChange(newArray)
        // reseteamos
        clear()
      }
      setShowPagoEdit(false)
    }
  }

  const handlePagoCancelarClick = () => {
    setShowPagoEdit(false)
    clear()
  }
  const onDeleteClick = (key: string) => {
    setSelectedItemId(key) // Store the item ID in the state
    setIsModalOpen(true)
  }
  //=========================================================================
  // FIN DE CLICKS EN BOTONES ==========================================

  /*
  Aca llega cuando hacel click a precio de venta o tasacion"
  */
  const tranSelected = (idx: number) => {
    setTranIndex(idx)
  }
  const tranCollection: RadioItem[] = [
    { label: 'Precio de venta' },
    { label: 'Tasación' },
    { label: 'No usar impuesto ni inscripción' },
  ]

  const esTransferencia = selectedIndex === 0
  const esTag = selectedIndex == 1
  const esOtro = selectedIndex === 2

  const handleConfirm = () => {
    setIsModalOpen(false)
    // Perform delete action here
    //setAdditionals(prevItems => prevItems.filter(item => item._id !== selectedItemId));
    const newArray = array.filter((item) => item._id !== selectedItemId)
    onPaymentsChange(newArray)
    console.log('Item deleted:' + selectedItemId)
    setSelectedItemId(null)
  }

  const handleCancel = () => {
    setIsModalOpen(false)
    setSelectedItemId(null)
  }
  const clear = (): void => {
    setNewAdditional(generateIni)
    setTransfer({ ...iniTransfer })
    setTag(iniTag)
    setOtro(iniOtro)
    setTranIndex(-1)
    setSelectedIndex(0)
  }

  const showDescription = (cost: Additional) => {
    return cost.description
  }

  return (
    <div>
      <div className="flex">
        <div className="text-2xl w-48">{title}</div>
        <div className="flex-1">
          <ButtonActionShort label="Agregar..." handleButtonClick={handleAgregarClick} />
        </div>
      </div>
      <div className="grid grid-cols-6 border-t">
        {array.map((cost) => (
          <React.Fragment key={cost._id}>
            <div className="border-b pr-4 col-span-3">{showDescription(cost)}</div>
            <div className="border-b pr-4">{formatDateEx(cost.date)}</div>
            <div className="border-b pr-4 text-right">${formatWithThousandSep(cost.cost)}</div>
            <button
              className="border-b pr-4 cursor-pointer hover:text-red-500 focus:outline-none focus:ring-2"
              onClick={() => onDeleteClick(cost._id)}
              aria-label="Delete"
            >
              &#x1F5D1;
            </button>
          </React.Fragment>
        ))}

        {isModalOpen && (
          <ConfirmationModal
            message="¿Estás seguro de eliminar este costo adicional?"
            onConfirm={handleConfirm}
            onCancel={handleCancel}
          />
        )}
      </div>

      {showPagoEdit && (
        <>
          <div className="mt-10">
            <ButtonMenuSet
              short={true}
              captions={['Transferencia de dominio', 'TAG', 'Otro']}
              clickedIndex={selectedIndex}
              handleButtonClick={(idx) => setSelectedIndex(idx)}
            />

            {selectedIndex > -1 && (
              <div>
                {esTransferencia && (
                  <div className="grid grid-cols-3 gap-4  mt-4">
                    <div>
                      <RadioGroup
                        collection={tranCollection}
                        name={'tipoTran'}
                        direction={'vertical'}
                        checked={tranIndex}
                        callback={tranSelected}
                        label="Impuesto compraventa"
                      />
                    </div>
                    <div>
                      <DisplayValueVert label="Valor calculado" value={transfer?.impuesto_format} />
                      <DisplayValueVert label="Inscripción" value={transfer?.inscripcion_format} />
                      <InputField
                        label="Otros transferencia"
                        name="varios_format"
                        value={transfer?.varios_format}
                        type="string"
                        handleInputChange={handleInputChangeTx}
                      />
                    </div>
                    <div>
                      <DisplayValueVert
                        label="Total transferencia"
                        value={transfer?.price_format}
                        name="price_format"
                        errors={errors}
                      />

                      <InputField
                        label="Fecha"
                        name="date"
                        value={transfer?.date}
                        type="date"
                        handleInputChange={handleInputChangeTx}
                        errors={errors}
                      />
                    </div>
                  </div>
                )}
                {esTag && (
                  <div className="flex flex-row gap-4  mt-4">
                    <InputField
                      label="Fecha"
                      name="date"
                      value={tag?.date}
                      type="date"
                      handleInputChange={handleInputChangeTag}
                      errors={errors}
                    />

                    <InputField
                      label="Valor"
                      name="price_format"
                      value={tag?.price_format}
                      type="string"
                      handleInputChange={handleInputChangeTag}
                      errors={errors}
                    />
                  </div>
                )}
                {esOtro && (
                  <div className="flex flex-row gap-4  mt-4">
                    <InputField
                      label="Descripción"
                      name="description"
                      value={otro?.description ?? ''}
                      type="text"
                      handleInputChange={handleInputChangeOtro}
                      errors={errors}
                    />

                    <InputField
                      label="Fecha"
                      name="date"
                      value={otro?.date}
                      type="date"
                      handleInputChange={handleInputChangeOtro}
                      errors={errors}
                    />

                    <InputField
                      label="Valor"
                      name="price_format"
                      value={otro?.price_format}
                      type="string"
                      handleInputChange={handleInputChangeOtro}
                      errors={errors}
                    />
                  </div>
                )}
              </div>
            )}
          </div>
          <div className="flex justify-center mt-4 space-x-4">
            <ButtonActionShort label="Aceptar" handleButtonClick={handlePagoAceptarClick} />
            <ButtonActionShort label="Cancelar" handleButtonClick={handlePagoCancelarClick} />
          </div>
        </>
      )}
    </div>
  )
}

export default ReservationAdicional
